import Vue from 'vue'
import App from './App.vue'
//import router from './router'
//import store from './store'
import vuetify from './plugins/vuetify';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGem, faWallet, faHandHoldingHeart, faHandHoldingMagic, faFileSignature, faBoxHeart, faBalanceScale, faMobileAndroid } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueProgressiveImage from 'vue-progressive-image'
 

library.add(faGem, faWallet, faHandHoldingHeart, faHandHoldingMagic, faFileSignature, faBoxHeart, faBalanceScale, faMobileAndroid )

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueProgressiveImage)
Vue.config.productionTip = false

new Vue({
  //router,
  //store,
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
